import Text from '@common/components/Text/Text'

import { ENavigator } from '../../navigator'
import activator      from '../../activator'

import styles from './Welcome.css'

class Welcome extends HTMLElement {
  public connectedCallback (): void {
    if (activator.isActivated()) {
      this.appendChild(<a-activated />)
    }
    else {
      const daysLeft = activator.getDaysLeft()

      this.appendChild(
        <Fragment>
          <Text.instance className={ styles.title } key="activator.welcome.title" />
          <br />
          <Text.instance className={ styles.choose } key="activator.welcome.choose" />

          <a-button-container>
            {
              daysLeft
                ? <a-button action={ ENavigator.Demo } icon="trial" key="activator.button.demo" replace={ daysLeft } />
                : <a-button disabled icon="trial" key="activator.button.demo_expired" />
            }

            <a-button action={ ENavigator.Licence } icon="activate" key="activator.button.activate" />
          </a-button-container>

          <Text.instance className={ styles.warning } key="activator.welcome.warning" />
        </Fragment>
      )
    }
  }
}

customElements.define('a-welcome', Welcome)
